import { create } from 'zustand';
import { TrendState } from '@/types/trend';

const useTrendStore = create<TrendState>(set => ({
  trendTimer: null,
  trendData: [],
  updateTrendData: data => set({ trendData: data }),
  setTrendTimer: timer => set({ trendTimer: timer })
}));

export default useTrendStore;
